'use client';

import * as Sentry from '@sentry/react';

import { CrehanaLayout } from '@crehana/layouts';

import { LanguageProvider } from '@/shared/contexts/Language';
import { cookieValues } from '@/shared/utils/cookies';

type TCommonLayoutsProps = {
  organizationSlug?: string;
};

export const CommonLayouts: React.FC<
  React.PropsWithChildren<TCommonLayoutsProps>
> = ({ children }) => {
  return (
    <LanguageProvider>
      <CrehanaLayout
        countryCode={cookieValues.country}
        renderCookiesBanner={false}
        isErrorPage={false}
        sentryInstance={Sentry}
      >
        {children}
      </CrehanaLayout>
    </LanguageProvider>
  );
};
